import { h, Fragment } from "preact";
import styled from "styled-components";
import {gridSize, fontColour, smallScreenThreshold} from "./style-variables";
// @ts-ignore
import menuBackground from "url:./menu-background.jpg";
import * as React from "preact/compat";
import {BrowserRouter, Link, Switch, Route, useRouteMatch, Redirect} from "react-router-dom";
import {
  RelayEnvironmentProvider,
  loadQuery
} from 'react-relay/hooks';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserCircle, faBook } from '@fortawesome/free-solid-svg-icons'
import graphql from 'babel-plugin-relay/macro'

import { Me } from "./me";
import { Projects } from "./projects";
import { Musings } from "./musings";
import {GRAPHQL_ENVIRONMENT} from "./musings/fetch-graphql";
import {Suspense} from "preact/compat";
import {LoadingIndicator} from "./common/Loading";
import {Page} from "./common/Page";
import {siteQuery} from "./__generated__/siteQuery.graphql";
import {MusingsRedirect} from "./musings/musings-redirect";

const StyledSite = styled.div`
    overflow-y: scroll;
  height: 100%;
  color: ${fontColour};
  display: flex;
  flex-direction: column;
  @media screen and (max-width: 800px) {
    width: 100%;   
  }
`;

const Menu = styled.ul`
  width: ${gridSize * 34}px; 
  height: ${gridSize * 4}px;
  box-sizing: border-box;
  position: relative;
  font-weight: bold;
  font-size: 30px;
  list-style: none;
  display: flex;
  justify-content: center;
  padding: ${gridSize}px 0;
  margin: 0 auto;
  @media screen and (max-width: ${smallScreenThreshold}) { 
    font-size: 40px;
    justify-content: space-between;
    width: auto;
    margin: 0 ${gridSize}px;   
  }
`;

const MenuItem = styled(Link)`
  padding: 0;
  display: inline-block;
  padding: ${gridSize / 2}px;
  cursor: pointer;
  opacity: ${props => props.isCurrent ? 1 : 0.2};
  color: ${fontColour};
  transition: opacity, 1s;

  &:visited,
  &:active {
    color: ${fontColour};
  }
  &:hover {
    opacity: 1;
  }
 
`;

export const blogpostsQuery = graphql`
  query siteQuery {
    blogCollection(order: sys_firstPublishedAt_DESC) {
      items {
        sys { firstPublishedAt, id }
        title
        blogContent { json }
      }
    }
  }
`;

export const blogPostsPreloadedQuery = loadQuery<siteQuery>(GRAPHQL_ENVIRONMENT, blogpostsQuery, {});

const NavigationMenu = () => {
  const routeMatch = useRouteMatch();
  return (
      <Menu>
        <MenuItem to="/about" isCurrent={routeMatch.path === "/about"} title="me"><FontAwesomeIcon icon={faUserCircle} /></MenuItem>
        <MenuItem to="/musings" isCurrent={routeMatch.path.includes("/musings")}> <FontAwesomeIcon icon={faBook} /> </MenuItem>
      </Menu>
  )
}

export const Site = () => {
  return (
      <RelayEnvironmentProvider environment={GRAPHQL_ENVIRONMENT}>
          <BrowserRouter>
            <StyledSite>
              <Switch>
                <Route path="/musings/:postId">
                  <>
                    <NavigationMenu />
                    <Suspense fallback={<Page> <LoadingIndicator /> </Page>}>
                      <Musings />
                    </Suspense>
                  </>
                </Route>
                <Route path="/musings">
                  <>
                    <Suspense fallback={<Page> <LoadingIndicator /> </Page>}>
                      <MusingsRedirect />
                    </Suspense>
                  </>
                </Route>
                <Route path="/projects">
                  <>
                    <NavigationMenu />
                    <Projects />
                  </>
                </Route>
                <Route path="/about">
                  <>
                    <NavigationMenu />
                    <Me />
                  </>
                </Route>
                <Route path="/">
                  <Redirect to="/musings" />
                </Route>
              </Switch>
            </StyledSite>
          </BrowserRouter>
      </RelayEnvironmentProvider>
  );
};
